import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import styles from './VpBillingHistory.module.less';

export const VpBillingHistory = ({ invoices }) => {
  const hasInvoices = !!invoices.length;
  return (
    <Box className={styles.vpBillingHistoryWrapper}>
      <Typography variant="h3" className={styles.vpPaymentInfoHeader}>
        Billing History
      </Typography>
      <Box className={styles.vpBillingHistoryTable}>
        <Typography variant="div" className={styles.vpBillingHistoryItem}>
          <Typography variant="span">Date</Typography>
          <Typography variant="span">Invoice Number</Typography>
          <Typography variant="span">Total</Typography>
          <Typography variant="span"></Typography>
        </Typography>
        {hasInvoices &&
          invoices.map((invoice) => {
            return (
              <Typography
                key={invoice.invoiceNumber}
                variant="div"
                className={styles.vpBillingHistoryItem}
              >
                <Typography variant="span">{invoice.date}</Typography>
                <Typography variant="span">{invoice.invoiceNumber}</Typography>
                <Typography variant="span">{invoice.value}</Typography>
                {invoice.downloadLink && (
                  <a href={invoice.downloadLink} className={styles.vpBillingHistoryActionField}>
                    Download
                  </a>
                )}
              </Typography>
            );
          })}
        {!hasInvoices && <Typography variant="span">No invoices available</Typography>}
      </Box>
    </Box>
  );
};

VpBillingHistory.propTypes = {
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      downloadLink: PropTypes.string.isRequired,
      invoiceNumber: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    }).isRequired
  ).isRequired
};

VpBillingHistory.defaultProps = {
  invoices: []
};

VpBillingHistory.displayName = 'VpBillingHistory';

export default VpBillingHistory;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpBillingHistory.jsx